<div
  class="col-md-12"
  *ngIf="isLoading"
  style="
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 99;
  "
>
  <app-busy [message]="message"></app-busy>
</div>

<fieldset
  class="scheduler-border"
  style="align-content: float-right; display: none"
>
  <legend class="scheduler-border tsk-display">Filters</legend>
  <!-- <legend class="scheduler-border tsk-display blackcontrol">Filters</legend> -->
  <div class="row" style="margin: 15px auto !important; padding-left: 0">
    <div
      class="col-3 table-responsive-sm"
      style="width: 100% !important; margin: 0px; padding: 0px"
    >
      <table
        class="table table-sm"
        style="width: 80% !important; margin: 0px; padding: 0px"
        border="0"
      >
        <tr class="rmp-all">
          <td class="col-md-2">
            <input
              type="text"
              style="width: 200px !important; height: 35px"
              class="form-control form-control-lg pull-left"
              [(ngModel)]="carrierName"
              placeholder="Filter by carrier name..."
              title="Enter the Carrier name to filter by..."
              (keypress)="checkKey($event)"
            />
          </td>
          <td class="col-md-2">
            <input
              type="text"
              style="width: 200px !important; height: 35px"
              class="form-control form-control-lg"
              [(ngModel)]="carrierNumber"
              placeholder="Filter by account number..."
              title="Enter the Account number to filter by..."
              (keypress)="checkKey($event)"
            />
          </td>
          <td class="col-md-2">
            <input
              type="text"
              style="width: 200px !important; height: 35px"
              class="form-control form-control-lg"
              [(ngModel)]="permitNumber"
              placeholder="Filter by permit number..."
              title="Enter the Permit number to filter by..."
              (keypress)="checkKey($event)"
            />
          </td>

          <td class="col-md-2">
            <input
              type="text"
              style="width: 200px !important; height: 35px"
              class="form-control form-control-lg"
              [(ngModel)]="companyRegNumber"
              placeholder="Filter by permit number..."
              title="Enter the Permit number to filter by..."
              (keypress)="checkKey($event)"
            />
          </td>
          <td class="col-md-2">
            <input
              type="text"
              style="width: 200px !important; height: 35px"
              class="form-control form-control-lg"
              [(ngModel)]="first_Name"
              placeholder="Filter by permit number..."
              title="Enter the Permit number to filter by..."
              (keypress)="checkKey($event)"
            />
          </td>
          <td class="col-md-2">
            <input
              type="text"
              style="width: 200px !important; height: 35px"
              class="form-control form-control-lg"
              [(ngModel)]="surname"
              placeholder="Filter by permit number..."
              title="Enter the Permit number to filter by..."
              (keypress)="checkKey($event)"
            />
          </td>
          <td class="col-md-2">
            <input
              type="text"
              style="width: 200px !important; height: 35px"
              class="form-control form-control-lg"
              [(ngModel)]="vehicle_Registration"
              placeholder="Filter by permit number..."
              title="Enter the Permit number to filter by..."
              (keypress)="checkKey($event)"
            />
          </td>
          <td class="col-md-2">
            <input
              type="text"
              style="width: 200px !important; height: 35px"
              class="form-control form-control-lg"
              [(ngModel)]="application_Number"
              placeholder="Filter by permit number..."
              title="Enter the Permit number to filter by..."
              (keypress)="checkKey($event)"
            />
          </td>

          <!-- <div class="col-4 resizer" style="width:350px; padding:0px" title="Select one or more statuses to filer by..."> -->
          <td class="col-3 resizer">
            <div
              class="col-9 resizer"
              style="width: 350px; padding: 0px"
              title="Select one or more statuses to filer by..."
            >
              <ng-multiselect-dropdown
                [placeholder]="'Filter by one or more statuses...'"
                [data]="statuses"
                [(ngModel)]="selectedItems"
                [settings]="dropdownSettings"
                (onSelect)="onItemSelect($event)"
                (onDeSelect)="onDeSelect($event)"
                (onSelectAll)="onSelectAll($event)"
              >
              </ng-multiselect-dropdown>
            </div>
          </td>
          <td>
            <span
              id="onSearchPermit"
              title="Apply filters..."
              (click)="onSearch()"
              class="btn btn-primary btn-sm pull-right"
              style="margin-right: 6px !important"
              ><i class="fa fa-filter" aria-hidden="true"></i
            ></span>
          </td>
          <td>
            <span
              (click)="onReset()"
              id="onResetPermit"
              title="Reset filters..."
              class="btn btn-success btn-sm pull-right"
              ><i class="fa fa-undo" aria-hidden="true"></i
            ></span>
          </td>
        </tr>
      </table>
    </div>
  </div>
</fieldset>

<div class="page_header">
  <h1 class="heading">Permits</h1>
</div>

<app-filter
  [carrierName]="carrierName"
  [carrierNumber]="carrierNumber"
  [selectedItems]="selectedItems"
>
</app-filter>

<fieldset style="margin:0px;padding:0px;">
	<div class="table-responsive">
		<table class="table table-sm custom_table">
			<thead class="thead-inverse">
				<tr class="hd-clpse">
					<th class="bfr-end-col text-center">
						Lock
					</th>
					<th class="bfr-end-col">
						Account Number
						<i class="fa fa-sort"
							[ngClass]="{'fa-sort-asc sort-a': (flags.flagAN == 2),'fa-sort-desc sort-d': (flags.flagAN == 3), 'fa-sort':(flags.flagAN == 1) }"
							(click)="onSort(1)"></i>

					</th>
					<th class="bfr-end-col">
						Account Id
						<i class="fa fa-sort"
							[ngClass]="{'fa-sort-asc sort-a': (flags.flagAI == 2),'fa-sort-desc sort-d': (flags.flagAI == 3), 'fa-sort':(flags.flagAI == 1) }"
							(click)="onSort(10)"></i>

					</th>
					<th class="bfr-end-col">
						Name
						<i class="fa fa-sort"
							[ngClass]="{'fa-sort-asc sort-a': (flags.flagNM == 2),'fa-sort-desc sort-d': (flags.flagNM == 3), 'fa-sort':(flags.flagNM == 1) }"
							(click)="onSort(2)"></i>
					</th>
					<!-- <th class="bfr-end-col">
				  Lead User
				  <i style="vertical-align:middle; float:right;" class="fa" [ngClass]="{'fa-sort-asc sort-a': (flags.flagLU == 2),'fa-sort-desc sort-d': (flags.flagLU == 3), 'fa-sort':(flags.flagLU == 1) }" (click)="onSort(3)"></i>
				</th>
				<th class="bfr-end-col">
				  Carrier Type
				  <i style="vertical-align:middle; float:right;" class="fa" [ngClass]="{'fa-sort-asc sort-a': (flags.flagCT == 2),'fa-sort-desc sort-d': (flags.flagCT == 3), 'fa-sort':(flags.flagCT == 1) }" (click)="onSort(4)"></i>
				</th> -->
          <th class="bfr-end-col">
            App
            <i
              class="fa fa-sort"
              [ngClass]="{
                'fa-sort-asc sort-a': flags.flagAP == 2,
                'fa-sort-desc sort-d': flags.flagAP == 3,
                'fa-sort': flags.flagAP == 1
              }"
              (click)="onSort(5)"
            ></i>
          </th>
          <!-- <th class="bfr-end-col">
				  Permit Num
				  <i style="vertical-align:middle; float:right;" class="fa" [ngClass]="{'fa-sort-asc sort-a': (flags.flagPN == 2),'fa-sort-desc sort-d': (flags.flagPN == 3), 'fa-sort':(flags.flagPN == 1) }" (click)="onSort(6)"></i>
				</th> -->
          <th class="bfr-end-col">
            Type
            <i
              class="fa fa-sort"
              [ngClass]="{
                'fa-sort-asc sort-a': flags.flagPT == 2,
                'fa-sort-desc sort-d': flags.flagPT == 3,
                'fa-sort': flags.flagPT == 1
              }"
              (click)="onSort(7)"
            ></i>
          </th>
          <th class="bfr-end-col text-center">Num Permits</th>
          <th class="text-right">
            Submitted On
            <i
              class="fa fa-sort"
              [ngClass]="{
                'fa-sort-asc sort-a': flags.flagDS == 2,
                'fa-sort-desc sort-d': flags.flagDS == 3,
                'fa-sort': flags.flagDS == 1
              }"
              (click)="onSort(8)"
            ></i>
          </th>
          <th class="bfr-end-col">
            Status
            <i
              class="fa fa-sort"
              [ngClass]="{
                'fa-sort-asc sort-a': flags.flagST == 2,
                'fa-sort-desc sort-d': flags.flagST == 3,
                'fa-sort': flags.flagST == 1
              }"
              (click)="onSort(9)"
            ></i>
          </th>
          <th class="bfr-end-col text-center">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr
          class="tbl-row"
          *ngFor="
            let item of permits
              | orderBy : criteria : direction
              | paginate
                : {
                    itemsPerPage: pageSize,
                    currentPage: utility.page,
                    totalItems: count
                  };
            let index = index
          "
        >
          <!-- <td class="bfr-end-col"><input  value="{{item.id}}" [ngModel]="selectedIndex === index"
					(change)="CheckedCarrier($event,item.id,item,index)"></td> -->
          <td class="bfr-end-col text-center">
            <span
              *ngIf="item.isLocked == true"
              title="Locked by '{{ item.isLockedBy }}', Click to unlock"
              style="margin: 0%"
              class="btn btn-md pull-center"
              (click)="unLockApplication(item)"
            >
              <i class="fa fa-lock" aria-hidden="true" style="color: red"></i>
            </span>
            <span
              *ngIf="item.isLocked == false || item.isLocked == undefined"
              title="Unlocked"
              style="margin: 0%"
              class="btn btn-md pull-center"
            >
              <i
                class="fa fa-unlock"
                aria-hidden="true"
                style="color: green"
              ></i>
            </span>
          </td>
          <td class="bfr-end-col">
            <a
              [routerLink]="['/carrier/permit/application/edit', item.id]"
              style="color: #00008b; text-decoration: underline"
              ><span title="View Permit">{{ item.AccountNumber }}</span></a
            >
          </td>
          <td class="bfr-end-col">{{ item.carrier.carrier_account_id }}</td>
          <td class="bfr-end-col" title="{{ item.Name }}">{{ item.Name }}</td>
          <!-- <td class="bfr-end-col">{{item.LeadUser}}</td>
				<td class="bfr-end-col">{{item.CarrierType}}</td> -->
          <td class="bfr-end-col text-center">
            {{ item.ApplicationNumber }}
          </td>
          <!-- <td class="bfr-end-col text-center">{{item.permit_num}}</td> -->
          <td class="bfr-end-col">{{ item.PermitType }}</td>
          <td
            class="bfr-end-col text-center"
            style="text-align: center !important"
          >
            {{ item.number_of_permits }}
          </td>
          <td class="bfr-end-col text-right">
            {{
              item.DateSubmitted?.toLocaleString() | date : "yyyy/MM/dd HH:mm"
            }}
          </td>
          <td class="bfr-end-col">
            {{ item.status_desc }}
          </td>
          <!-- <td style="align-items: center;"> <img src="../../../assets/newimg/folder-dublicate-fill@2x.svg" class="process" /> -->
          <td class="text-center">
            <span class="actions_wrap">
              <span
                style="display: none"
                title="View\Edit Permit Application"
                class="btn btn-primary btn-sm pull-left"
                id="viewEditPermit"
                (click)="
                  viewEditApplication(
                    selectedPermit.id,
                    selectedPermit.status_desc
                  )
                "
                ><i class="fa fa-list" aria-hidden="true"></i
              ></span>
              <span
                *ngIf="item.isLocked != true"
                id="processPermitApplication"
                title="Process Permit Application"
                style="margin: 0%"
                class="action_btn"
                (click)="onProcessClick(selectedPermit, item)"
              >
                <img src="/assets/permit-viewer2.png" class="permit-view" />
              </span>

              <span
                *ngIf="
                  item.isLocked == true && item.isLockedBy == currentUserName
                "
                id="processPermitApplication"
                title="Process Permit Application"
                style="margin: 0%"
                class="action_btn"
                (click)="onProcessClick(selectedPermit, item)"
              >
                <img src="/assets/permit-viewer2.png" class="permit-view" />
              </span>

              <span
                style="background-color: grey; display: none"
                *ngIf="
                  item.isLocked == true && item.isLockedBy != currentUserName
                "
                title="application locked"
                style="margin: 0%"
                class="action_btn"
              >
                <img
                  style="background-color: grey"
                  src="/assets/permit-viewer2.png"
                  class="permit-view"
                />
              </span>
              <button
                [disabled]="
                  !(
                    (isPrintable(item.status_id) && !item.isLocked) ||
                    (isPrintable(item.status_id) &&
                      item.isLocked &&
                      item.isLockedBy != '' &&
                      item.isLockedBy != null &&
                      item.isLockedBy != undefined &&
                      item.isLockedBy == currentUserName)
                  )
                "
                title="Print permits"
                style="margin: 0%; margin-left: 5px"
                class="action_btn"
                id="printPermit"
                (click)="onProcessPrint(item)"
              >
                <i class="fa fa-print" aria-hidden="true"></i>
              </button>
              <button
                *ngIf="selectedPermit"
                style="margin: 0%; display: none"
                [routerLink]="[
                  '/carrier/modify/permit/application/' + selectedPermit.id
                ]"
                id="actionModifyPermitDetails"
              >
                Modify
              </button>
            </span>

            <span style="display: none">
              <span
                title="View\Edit Permit Application"
                class="btn btn-primary btn-sm pull-left"
                id="viewEditPermit"
                (click)="
                  viewEditApplication(
                    selectedPermit.id,
                    selectedPermit.status_desc
                  )
                "
                ><i class="fa fa-list" aria-hidden="true"></i
              ></span>
              <span
                *ngIf="item.isLocked != true"
                id="processPermitApplication"
                title="Process Permit Application"
                style="margin: 0%"
                value=" {{ item }}"
                class="btn btn-success btn-sm pull-center myButton"
                (click)="onProcessClick(selectedPermit, item)"
              >
                <img src="/assets/permit-viewer2.png" class="permit-view" />
              </span>

              <span
                *ngIf="
                  item.isLocked == true && item.isLockedBy == currentUserName
                "
                id="processPermitApplication"
                title="Process Permit Application"
                style="margin: 0%"
                item
                class="btn btn-success btn-sm pull-center"
                (click)="onProcessClick(item)"
              >
                <img src="/assets/permit-viewer2.png" class="permit-view" />
              </span>

              <span
                style="background-color: grey; display: none"
                *ngIf="
                  item.isLocked == true && item.isLockedBy != currentUserName
                "
                title="application locked"
                style="margin: 0%"
                class="btn btn-secondary btn-sm pull-center"
              >
                <img
                  style="background-color: grey"
                  src="/assets/permit-viewer2.png"
                  class="permit-view"
                />
              </span>
              <button
                [disabled]="
                  !(
                    (isPrintable(item.status_id) && !item.isLocked) ||
                    (isPrintable(item.status_id) &&
                      item.isLocked &&
                      item.isLockedBy != '' &&
                      item.isLockedBy != null &&
                      item.isLockedBy != undefined &&
                      item.isLockedBy == currentUserName)
                  )
                "
                title="Print permits"
                style="margin: 0%; display: none"
                class="btn btn-secondary btn-sm pull-right buttonMy"
                id="printPermit"
                (click)="onProcessPrint(selectedPermit)"
              >
                <i class="fa fa-print" aria-hidden="true"></i>
              </button>
            </span>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr *ngIf="count > 10" class="pagination_row">
          <td colspan="12" class="rm-brd">
            <div class="row">
              <div class="col-2">
                <div
                  class="input-group mb-3 rm-brd"
                  style="width: 125px !important; height: 30px !important"
                >
                  <div class="input-group-prepend">
                    <label
                      class="input-group-text form-control-sm show-h"
                      for="show-id"
                      >Show:</label
                    >
                  </div>
                  <select
                    class="form-control form-control-sm show-h"
                    id="show-id"
                    [(ngModel)]="pageSize"
                    (change)="onChange()"
                  >
                    <option
                      *ngFor="let key of utility.pageItems"
                      [ngValue]="key"
                    >
                      {{ key }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-10">
                <pagination-controls
                  (pageChange)="utility.page = onNextOrPrevious($event)"
                  style="margin-right: 0px !important; float: right !important"
                ></pagination-controls>
              </div>
            </div>
          </td>
        </tr>
        <tr *ngIf="isEmpty">
          <td colspan="4" class="rm-brd">
            <span class="text-info text-small"
              >No permit applications found.</span
            >
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
</fieldset>
